import { defineStore } from 'pinia';
import {
  initialProspect,
  initial_filters,
} from '../models/prospect_model.js';
import api from '@/services/api';
import { getParamsUrl } from '../prospect_utils.js';
import { useAuthStore } from '../../auth/auth_store';
import { Role } from '@/enum/roles_enum.js';
export const useProspectStore = defineStore('prospectStore', {
  state: () => ({
    prospect: { ...initialProspect },
    filters: { ...initial_filters },
    prospects: [],
    page: 1,
    isNewModalOpen: false,
  }),
  actions: {
    async findAllProspectsHTTP() {
      const authStore = useAuthStore();
      const usuario = authStore.usuario();
      const esEjecutivoDeVentas = usuario.roles.some(
        (rol) => rol.Codigo === Role.EJECUTIVO_DE_VENTAS,
      );
      if (esEjecutivoDeVentas) {
        this.filters.CodigoEjecutivo = usuario.Codigo;
      } else {
        this.filters.CodigoEjecutivo = null;
      }
      const result = await api.get(
        `/cliente?${getParamsUrl({ ...this.filters, limit: this.limit || 25, page: +this.page })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.prospects.push(...result.data);
        this.setPage(this.page + 1); // Incrementa la página para la próxima carga
        return true;
      }
      return false;
    },
    async newProspectHTTP() {
      const payload = { ...this.prospect };
      if (this.prospect.VendedorPrincipal) {
        payload.CodigoVendedorPrincipal = this.prospect.VendedorPrincipal;
      }
      if (this.prospect.VendedorSecundario) {
        payload.CodigoVendedorSecundario = this.prospect.VendedorSecundario;
      }
      if (this.prospect.Clasificacion) {
        payload.CodigoClasificacion = this.prospect.Clasificacion.Codigo;
      }
      delete payload.VendedorPrincipal;
      delete payload.VendedorSecundario;

      const response = await api.post('/cliente', payload);
      if (
        response.status === 200 ||
        (response.status === 201 && response.data !== 'El cliente ingresado ya existe')
      ) {
        this.resetProspect();
        return true;
      }

      return false;
    },
    async findProspectByCodigoHTTP(codigo) {
      try {
        const result = await api.get(`/cliente/${codigo}`);
        if (result && result.data) {
          this.prospect = result.data;
        }
      } catch (error) {
        console.error('Error en findProspectByCodigoHTTP:', error);
      }
    },
    async updateProspectHTTP() {
      delete this.prospect.UsuarioVendedorPrincipal;
      delete this.prospect.UsuarioVendedorSecundario;
      const codigo = this.prospect.Codigo;
      const response = await api.patch(`/cliente/${codigo}`, this.prospect);
      if (response.status === 200) {
        this.resetProspect();
      }
    },
    async saveProspect() {
      if (this.prospect.Codigo) {
        await this.updateProspectHTTP();
      } else {
        await this.newProspectHTTP();
      }
    },
    async firstProspects() {
      this.setPage(1);
      this.emptyList();
      await this.findAllProspectsHTTP();
    },
    async searchProspectsHTTP(query, codigoUsuario) {
      const authStore = useAuthStore();
      const usuario = authStore.usuario();
      const esEjecutivoDeVentas = usuario.roles.some(
        (rol) => rol.Codigo === Role.EJECUTIVO_DE_VENTAS,
      );
      let url = `/cliente/description?Descripcion=${encodeURIComponent(query)}&page=1`;

      if (esEjecutivoDeVentas) {
        url += `&CodigoUsuario=${encodeURIComponent(usuario.Codigo)}`;
      }
      const result = await api.get(url);
      if (result && result.data && result.data.length > 0) {
        return [...result.data];
      }
      return [];
    },
    resetProspect() {
      this.prospect = { ...initialProspect };
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.prospects = [];
    },
    resetFilter() {
      this.filters = { ...initial_filters };
    },
    showNewModal() {
      this.isNewModalOpen = true;
    },
    hideNewModal() {
      this.isNewModalOpen = false;
    },
  },
});
